<template>
  <div>
    <div class="card cardcontents maincardlayer">
      <div class="card-header non-label-icon mapheader maincardheader">
        통합개선 이행율 현황
        <div class="card-more main-header-input">
          <c-plant
            type="search"
            label=""
            name="plantCd"
            v-model="plantCd"
            @datachange="getImprStatus" />
        </div>
        <div class="card-more main-header-input">
          <c-datepicker
            type="year"
            default="today"
            name="actionCompleteRequestDates"
            v-model="grid.actionCompleteRequestDates"
            @datachange="getImprStatus"
          />
        </div>
      </div>
      <div class="card-body row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <apexchart 
            ref="imprChart1" 
            height="300px" 
            type="bar"
            :options="imprChart1.chartOptions" 
            :series="imprChart1.series"
            @dataPointSelection="(event, chartContext, opts) => selectedBarImp(event, chartContext, opts, 'ENV')"/>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <apexchart 
            ref="imprChart2" 
            height="300px" 
            type="bar"
            :options="imprChart2.chartOptions" 
            :series="imprChart2.series"
            @dataPointSelection="(event, chartContext, opts) => selectedBarImp(event, chartContext, opts, 'SAFETYHEALTH')"/>
        </div>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import selectConfig from '@/js/selectConfig';
// let thisVue = this;
export default {
  name: 'main-impr-rate',
  components: { 
    apexchart: VueApexCharts
  },
  props: {
    isManage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imprChart1: {
        chartOptions: {
          title: {
            text: '환경팀'
          },
          annotations: { 
            xaxis: [],
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            hideOverflowingLabels: false,
            enabled: true,
            formatter: function(val) {
              return val !== 0 ? val : ''
            },
            style: {
              fontSize: '12px',
            }
          },
          stroke: {
            show: true,
            width: 1,
            colors: ['transparent']
          },
          xaxis: {
            categories: [],
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " 건"
              }
            }
          },
          colors: ['#0A6847', '#00BCD4', '#F44336',],
          fill: {
            opacity: 1,
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10,
            // customLegendItems: ['조치중', '개선완료(총합)', '지연 건수'],
          },
        },
        series: [],
        chartWidth: '100%',
      },
      imprChart2: {
        chartOptions: {
          title: {
            text: '안전보건팀'
          },
          annotations: { 
            xaxis: [],
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded',
            },
          },
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            hideOverflowingLabels: false,
            enabled: true,
            formatter: function(val) {
              return val !== 0 ? val : ''
            },
            style: {
              fontSize: '12px',
            }
          },
          stroke: {
            show: true,
            width: 1,
            colors: ['transparent']
          },
          xaxis: {
            categories: [],
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " 건"
              }
            }
          },
          colors: ['#0A6847', '#00BCD4', '#F44336',],
          fill: {
            opacity: 1,
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10,
            // customLegendItems: ['조치중', '개선완료(총합)', '지연 건수'],
          },
        },
        series: [],
        chartWidth: '100%',
      },
      grid: {
        listUrl: '',
        actionCompleteRequestDates: [],
      },
      sop4mClassItems: [],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      plantCd: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  methods: {
    init() {
      // url setting
      this.grid.listUrl = selectConfig.main.imprChart.url
      this.$comm.getComboItems('SOP_4M_CLASS_CD').then(_result => {
        this.sop4mClassItems = _result
      });
      // list setting
      this.getImprStatus();
    },
    getImprStatus() {
      this.$http.url = this.grid.listUrl;
      this.$http.type = 'GET';
      this.$http.isLoading = false;
      this.$http.param = {
        plantCd: this.plantCd,
        imprYear: this.grid.actionCompleteRequestDates,
      }
      this.$http.request((_result) => {
        let series1 = this.$_.filter(_result.data, { ibmTaskTypeCd: 'ITT0000135' }) // 환경
        let series2 = this.$_.filter(_result.data, { ibmTaskTypeCd: 'ITT0000060' }) // 안전보건
        this.$set(this.imprChart1, 'series', [
          {
            name: '조치중',
            data: this.$_.map(series1, 'actioning')
          },
          {
            name: '개선완료(총합)',
            data: this.$_.map(series1, 'complete')
          },
          {
            name: '지연 건수',
            data: this.$_.map(series1, 'overAction')
          },
        ])
        this.$set(this.imprChart2, 'series', [
          {
            name: '조치중',
            data: this.$_.map(series2, 'actioning')
          },
          {
            name: '개선완료(총합)',
            data: this.$_.map(series2, 'complete')
          },
          {
            name: '지연 건수',
            data: this.$_.map(series2, 'overAction')
          },
        ])
        let rate1 = [];
        let rate2 = [];
        this.$_.forEach(series1, item => {
          rate1.push(item.requestTotal > 0 ? String(this.$_.floor((item.complete / item.requestTotal) * 100)) + '%' : '')
        })
        this.$_.forEach(series2, item => {
          rate2.push(item.requestTotal > 0 ? String(this.$_.floor((item.complete / item.requestTotal) * 100)) + '%' : '')
        })
        let xaxis1 = this.$_.map(series1, 'gubun');
        let xaxis2 = this.$_.map(series2, 'gubun');
        let annotations1 = [];
        let annotations2 = [];
        rate1.forEach((r, idx) => {
          annotations1[idx] = {
            x: xaxis1[idx],
            strokeDashArray: 0,
            borderColor: '#EEEEEE',
            borderWidth: 0,
            label: {
              borderColor: '#775DD0',
              orientation: 'horizontal',
              style: {
                color: '#fff',
                fontSize: '12px',
                background: '#775DD0',
              },
              text: r ? r : '',
            }
          };
        });
        rate2.forEach((r, idx) => {
          annotations2[idx] = {
            x: xaxis2[idx],
            strokeDashArray: 0,
            borderColor: '#EEEEEE',
            borderWidth: 0,
            label: {
              borderColor: '#775DD0',
              orientation: 'horizontal',
              style: {
                color: '#fff',
                fontSize: '12px',
                background: '#775DD0',
              },
              text: r ? r : '',
            }
          };
        });

        this.imprChart1.chartOptions.xaxis.categories = xaxis1;
        this.imprChart2.chartOptions.xaxis.categories = xaxis2;
        this.imprChart1.chartOptions.annotations.xaxis = annotations1;
        this.imprChart2.chartOptions.annotations.xaxis = annotations2;
        
        this.imprChart1.chartWidth = '100%';
        this.imprChart2.chartWidth = '100%';

        this.setChart('imprChart1', 1600);
        this.setChart('imprChart2', 1600);
      },);
    },
    setChart(_target) {
      this.$refs[_target].refresh();
    },
    selectedBarImp(event, chartContext, opts, flag) {
      let stepGubun = '';
      switch (opts.w.config.series[opts.seriesIndex].name) {
        case '조치중':
          stepGubun = 'actioning'
          break;
        case '개선완료(총합)':
          stepGubun = 'complete'
          break;
        case '지연 건수':
          stepGubun = 'overAction'
          break;
        default:
          break;
      }
      let sop4mClassCd = '';
      if (flag === 'SAFETYHEALTH') {
        sop4mClassCd = this.$_.find(this.sop4mClassItems, { codeName: opts.w.config.xaxis.categories[opts.dataPointIndex] }).code
      }
      this.popupOptions.width = '90%';
      this.popupOptions.title = "개선목록 (업무별 현황)";
      this.popupOptions.param = {
        plantCd: this.plantCd4,
        ibmTaskTypeCd: flag === 'SAFETYHEALTH' ? 'ITT0000060' : 'ITT0000135',
        actionCompleteRequestDates: [this.grid.actionCompleteRequestDates + '-01-01', this.grid.actionCompleteRequestDates + '-12-31'],
        patrolGubun: flag,
        year: this.grid.actionCompleteRequestDates,
        itemGubun: opts.w.config.xaxis.categories[opts.dataPointIndex],
        stepGubun: stepGubun,
        sop4mClassCd: sop4mClassCd,
        isMain: true,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/impr.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  }
};
</script>